import React, { useEffect } from "react";
import MoreVert from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Popper, Tooltip } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import Settings from "../Settings";
import InvitePopper from "../InvitePopper";
import "./index.css";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import { loadState, saveState } from "../../utils/localStorage.utils";
import { LocalStorageKeys } from "../../utils/strings.utils";
import { setIfHyperlink } from "../../store/reducers/settings";
import DirectMessage from "../DirectMessage";
import SocialConnection from "../SocialConnection";
import { getFeatures } from "../../config";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { createClickEngagementRecorder } from "../../utils/api";

const IconMenuList = () => {
  const dispatch = useAppDispatch();
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    clickRecorder("menu");
    setAnchorEl(open ? null : event.currentTarget);
  };
  const isInIframe = window.location !== window.parent.location;
  const { FEATURE_DM_Contact_ENABLED } = getFeatures();
  const { logout, logined, isProticoAuthenticated } = useWeb3Auth();
  const { t } = useTranslation();
  const onClockLogout = () => {
    clickRecorder("menu-logout");
    logout();
    setAnchorEl(null);
  };

  useEffect(() => {
    try {
      const ifHyperlinkLocal =
        loadState(LocalStorageKeys.IF_HYPERLINK) ?? false;
      saveState(LocalStorageKeys.IF_HYPERLINK, ifHyperlinkLocal);
      dispatch(setIfHyperlink(ifHyperlinkLocal));
    } catch ({ message }) {
      console.error(`Can't get local storage, reason: (${message})`);
    }
  }, []);

  return (
    <>
      <IconButton onClick={handleClick}>
        {open ? (
          <CloseIcon color="action" fontSize="small" />
        ) : (
          <MoreVert color="action" fontSize="small" />
        )}
      </IconButton>
      <Popper
        id="IconMenuList-menu"
        open={open}
        anchorEl={anchorEl}
        className="IconMenuList"
      >
        {!isInIframe && isProticoAuthenticated && <InvitePopper />}
        {FEATURE_DM_Contact_ENABLED && (
          <>
            <div>
              <SocialConnection />
            </div>
            <div>
              <DirectMessage />
            </div>
          </>
        )}
        <Settings />
        {logined && (
          <Tooltip
            title={t("Menu_Logout")}
            placement="left-end"
            arrow
            disableInteractive
          >
            <IconButton aria-label="invite" onClick={onClockLogout}>
              <LogoutIcon color="action" fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Popper>
    </>
  );
};

export default IconMenuList;
